import Spinner from 'components/Spinner/Spinner'
import NewStaticTable from 'components/staticTable/NewStaticTable'
import { FormikProps } from 'formik'
import InputText from 'global/InputText/InputText'
import Modal from 'global/Modal/Modal'
import QrScanner from 'global/scanner'
import React, { useEffect, useRef, useState } from 'react'
import { BiTrash } from 'react-icons/bi'
import { BsUpcScan } from 'react-icons/bs'
import { MdPlaylistAdd } from 'react-icons/md'
import { toast } from 'react-toastify'
import useDebounce from 'tools/hooks/useDebounce'

type BarcodeItem = {
  serialNumber: string
}

type ConsignmentsProps = {
  barcodelists?: BarcodeItem[]
  setBarcodeLists?: (barcodes: BarcodeItem[]) => void
  formik?: FormikProps<any>
  isList?: boolean
  columns?: any
  handleScan?: (decodedText: string, mainBarcode?: string) => void
  deleteCprNumber?: (cpr: number) => void
  simpleMode?: boolean
  value?: string
  onValueChange?: (value: string) => void
  onAdd?: (value: string) => void
  label?: string
  palceholder?: string
  showResponse?: boolean
  classNames?: string
  wrapperClassName?: string
  important?: boolean
  name?: string
  error?: any
  maxLength?: number
  showAddButton?: boolean
  selectAble?: boolean
  selectedState?: any
  setselectedState?: any
  readOnly?: boolean
  handleChange?: any
  renderListItem?: (
    item: any,
    index: number,
    onDelete: (item: any) => void
  ) => React.ReactNode
  loading?: boolean
  isCleanText?:boolean
}

export function convertScannedItem(value: string): string {
  const strValue = String(value)
  if (strValue.length === 13 && /^\d+$/.test(strValue)) {
    return strValue
  }
  if (strValue.length === 24) {
    // const startsWithB = strValue.startsWith('B')
    const startsWithNine = strValue.startsWith('9')
    // const startsWithElevenZeros = strValue.startsWith('00000000000')
    // if (startsWithB || startsWithNine || startsWithElevenZeros) {

    console.log(startsWithNine)
    if ( startsWithNine ) {
      return strValue.substring(11, 24)
    }
    return strValue
  }
  // const match = strValue.match(/.{10}(\d{13})/)
  
  // if (match && match[1]) {
  //   return match[1]
  // }
  return strValue
}

function ScanConsignments({
  barcodelists = [],
  setBarcodeLists,
  formik,
  isList = false,
  columns,
  handleScan,
  deleteCprNumber,
  simpleMode = false,
  value,
  onValueChange,
  onAdd,
  label,
  palceholder,
  showResponse = true,
  classNames,
  wrapperClassName = 'w-full',
  important = false,
  name,
  error,
  maxLength,
  showAddButton = true,
  selectAble,
  selectedState,
  setselectedState,
  readOnly,
  handleChange,
  renderListItem,
  loading,
  isCleanText=true
}: ConsignmentsProps) {
  const [openScan, setOpenScan] = useState(false)
  const [scanValue, setScanValue] = useState('')
  const debouncedScanValue = useDebounce(scanValue, 20)
  const scanningRef = useRef(false)

  async function onScan(decodedText: string) {
    if (scanningRef.current) return
    scanningRef.current = true

    const cleanedText =isCleanText ? convertScannedItem(decodedText):decodedText

    try {
      if (simpleMode) {
        handleScan?.(cleanedText, decodedText)
        onValueChange?.('')
        return
      }

      const isExist = barcodelists.some((b) => b.serialNumber === cleanedText)

      if (isExist) {
        toast.error('شماره بارکد تکراری است')
        return
      }

      if (handleScan) {
        handleScan(cleanedText, decodedText)
        return
      }

      setBarcodeLists?.([...barcodelists, { serialNumber: cleanedText }])
    } finally {
      setScanValue('')
      formik?.setFieldValue('consignmentId', '')
      setTimeout(() => {
        scanningRef.current = false
      }, 100)
    }
  }

  useEffect(() => {
    if (!debouncedScanValue) return

    const cleaned = convertScannedItem(debouncedScanValue)
    const hasLetter = /[a-zA-Z]/.test(cleaned)
    if (
      cleaned.length === 13 ||
      cleaned.length === 24 ||
      (cleaned.length >= 5 && hasLetter)
    ) {
      onScan(debouncedScanValue)
      setScanValue('')
    }
  }, [debouncedScanValue])

  const inputValue = simpleMode ? value : formik?.values?.consignmentId
  const inputName = name || (simpleMode ? 'scanValue' : 'consignmentId')

  const handleInputChange = (e) => {
    const val = e.target.value

    if (simpleMode) {
      onValueChange?.(val)
      setScanValue(val)
      handleChange(e)
      return
    }
    if (handleChange) {
      handleChange(e)
      return
    }
    formik?.setFieldValue('consignmentId', val)
    setScanValue(val)
  }

  const handleDelete = (item) => {
    if (deleteCprNumber) {
      deleteCprNumber(item)
      return
    }
    setBarcodeLists?.(
      barcodelists.filter((b) => b.serialNumber !== item.serialNumber)
    )
  }

  const handleAddClick = () => {
    if (simpleMode && onAdd) {
      onAdd(inputValue)
    } else {
      onScan(formik?.values?.consignmentId)
    }
  }
  return (
    <>
      <InputText
        wrapperClassName={wrapperClassName}
        label={label}
        classNames={classNames || 'min-w-[20rem]'}
        important={important}
        placeholder={palceholder || 'اسکن یا ورود بارکد'}
        handleChange={handleInputChange}
        handleKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault()
            setScanValue(inputValue)
          }
        }}
        leftIcon={
          <div className='flex gap-3'>
            <button type='button' onClick={() => setOpenScan(true)}>
              <BsUpcScan size={30} className='text-[#EAB308]' />
            </button>
            {showAddButton && (
              <button type='button' onClick={handleAddClick}>
                <MdPlaylistAdd size={30} className='text-[#E74C3C]' />
              </button>
            )}
          </div>
        }
        name={inputName}
        values={inputValue}
        error={error}
        maxLength={maxLength}
        readOnly={readOnly}
      />
      {loading && <Spinner />}
      {!simpleMode && showResponse && (
        <div className=''>
          {isList ? (
            barcodelists?.map((item, index) =>
              renderListItem ? (
                <React.Fragment key={index}>
                  {renderListItem(item, index, handleDelete)}
                </React.Fragment>
              ) : (
                <div
                  key={item.serialNumber}
                  className='flex justify-between border-2 border-x-gray-200 my-2 rounded-xl py-4 px-2'
                >
                  <p>{item?.serialNumber}</p>
                  <button type='button' onClick={() => handleDelete(item)}>
                    <BiTrash size={20} className='w-full h-full' />
                  </button>
                </div>
              )
            )
          ) : (
            <NewStaticTable
              data={barcodelists.map((item, index) => {
                return {
                  ...item,
                  row: index + 1,
                  id: item?.serialNumber,
                  serialNumber: item?.serialNumber,
                  operation: (
                    <button type='button' onClick={() => handleDelete(item)}>
                      <BiTrash size={20} className='w-full h-full' />
                    </button>
                  ),
                }
              })}
              column={
                columns || [
                  {
                    accessor: 'row',
                    Header: 'ردیف',
                  },
                  {
                    accessor: 'serialNumber',
                    Header: 'شماره بارکد',
                  },
                  {
                    accessor: 'operation',
                    Header: 'عملیات',
                  },
                ]
              }
              pagination={1}
              selectAble={selectAble}
              selectedState={selectedState}
              setselectedState={setselectedState}
              ignoreRedux={true}
            />
          )}
        </div>
      )}
      <Modal visible={openScan} setVisible={setOpenScan} title='اسکن'>
        {openScan && (
          <QrScanner
            onSuccess={(text) => {
              setOpenScan(false)
              setScanValue(text)
            }}
          />
        )}
      </Modal>
    </>
  )
}

export default ScanConsignments
